module.exports = __webpack_public_path__ + "static/media/icon-chase-net.44b4bcd4.png";